const FORMFLOW_CREATEFORM_ITEM_TYPES = {
    UPLOAD: "UPLOAD",
    FORM: "FORM",
    WORKFLOW: "WORKFLOW",
    DISPLAY: "DISPLAY",
};


// https://www.lindo.com/doc/online_help/lingo15_0/logical_operators.htm
// Binary relation  https://en.wikipedia.org/wiki/Binary_relation
const LOGICAL_OPERATORS = {
    EQ: "EQ",
    NE: "NE",
    GT: "GT",
    GE: "GE",
    LT: "LT",
    LE: "LE",
};

const COLOR_QUALITATIVE_10 = [
    "#5B8FF9",
    "#5AD8A6",
    "#5D7092",
    "#F6BD16",
    "#6F5EF9",
    "#6DC8EC",
    "#945FB9",
    "#FF9845",
    "#1E9493",
    "#FF99C3",
];

const COLOR_QUALITATIVE_20 = [
    "#5B8FF9",
    "#CDDDFD",
    "#5AD8A6",
    "#CDF3E4",
    "#5D7092",
    "#CED4DE",
    "#F6BD16",
    "#FCEBB9",
    "#6F5EF9",
    "#D3CEFD",
    "#6DC8EC",
    "#D3EEF9",
    "#945FB9",
    "#DECFEA",
    "#FF9845",
    "#FFE0C7",
    "#1E9493",
    "#BBDEDE",
    "#FF99C3",
    "#FFE0ED",
];


export default {
    FORMFLOW_CREATEFORM_ITEM_TYPES,
    HOSPITAL_UNDERLAY_TRANSFERED_CODE: 120005,
    NO_AUTH_CODE: 198014, // 未登录code
    EXPIRED_CODE: 120004,
    // Deprecated_and_obsolete
    // @deprecated
    BASE_URL: "../",

    THROTTLE_TIME: 500, // 单位 ms
    PAGE_SIZE: 15,
    LOGICAL_OPERATORS,
    COLOR_QUALITATIVE_10,
    COLOR_QUALITATIVE_20,
    HOTLINE: "400 850 2660",
    TOKEN_NAME: "RENYUAN_corp_access_token",
};

// preventExtensions
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/preventExtensions
// The Object.preventExtensions() method prevents new properties from ever being added to an object
// (i.e. prevents future extensions to the object).

// seal
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/seal
// The Object.seal() method seals an object, preventing new properties from being added to it and marking all existing properties as non-configurable.
// Values of present properties can still be changed as long as they are writable.


// freeze
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
// The Object.freeze() method freezes an object: that is, prevents new properties from being added to it;
// prevents existing properties from being removed; and prevents existing properties, or their enumerability,
// configurability, or writability, from being changed, it also prevents the prototype from being changed.
// The method returns the object in a frozen state.
